import React, { useState, useEffect } from 'react';
import LeftSideNavigation from '../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation';
import HomeReusableTopBarNavigation from '../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation';
import { Table, Image, Button, Col, Form } from 'react-bootstrap';
import { NavLink, useHistory } from 'react-router-dom';
import { Menu, MenuItem } from '@material-ui/core';
import { get_experiences_admin } from '../../../../../store/actions/Experience/adminExperienceAction';
import { useDispatch, useSelector } from 'react-redux';
import NoContent from '../../../../reusableComponents/NoContentComponent';
import moment from 'moment';
import { Toggle } from '../../../superAdminReusable/reusableSuperAdminButton/Toggle';
import { vendorDashboardfromAdmin } from '../../../../../store/actions/vendorAccessActions';
import { EXPERIENCE_MANAGEMENT_DATA_ADMIN } from '../../../../../store/types';
import { SuperAdminDeleteExp } from '../../../../vendorDashboardComponents/Experiences/Experiencedashboard/DeleteExp';
import SelectFilter from '../../../../reusableComponents/selectFilter';
import BasicPagination from '../../../../Pagination/Pagination';
import StatusFilter from '../../../../vendorDashboardComponents/Experiences/Experiencedashboard/Modals/StatusFilter';
// import ViewExpDetails from "../../../../vendorDashboardComponents/Experiences/Experiencedashboard/ViewExpDetails";
import ViewExpDetails from '../../../../vendorDashboardComponents/Experiences/Experiencedashboard/ViewExpDetails';
import ViewExpSessions from '../../../../vendorDashboardComponents/Experiences/Experiencedashboard/ViewExpSessions';
import ShareLinkModal from '../../../../reusableComponents/ShareLinkModal';
import { webappUrl } from '../../../../../config/Keys';

const MerchantExperienceManagementDashboard = () => {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const [isActive, setActive] = useState(false);
  const [search, setSearch] = useState('');
  const [filtervalueModl, setFiltervaluefromModal] = useState('');

  const experiences = useSelector(
    (state) => state?.superAdminExperience?.experiences
  );
  const archivedExps = useSelector(
    (state) => state?.superAdminExperience?.archivedExps
  );

  const [type, setType] = useState(0);
  const getData = async () => {
    dispatch(
      get_experiences_admin(
        auth?.user?.accessToken,
        type === 0 ? 'EXPERIENCES' : 'ARCHIVED'
      )
    );
  };
  useEffect(() => {
    if (!experiences?.length || !archivedExps?.length) getData();
  }, [type]);

  const removeExp = (id, active) => {
    let exp = experiences.filter((ele) => ele?._id !== id);

    dispatch({
      type: EXPERIENCE_MANAGEMENT_DATA_ADMIN,
      payload: exp,
    });
  };
  // Pagination
  const [pagination, setPagination] = useState({
    page: 1,
    start: 0,
    end: 10,
  });

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setPagination({
      ...pagination,
      start: calcStart,
      end: pageNo * 10,
      page: pageNo,
    });
  };

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userSort, setUserSort] = useState(0);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  let _data = type === 0 ? experiences : archivedExps;
  let filteredData = _data;
  if (search) {
    let searchData = new RegExp(search, 'i');
    filteredData = _data.filter((getall) => {
      if (searchData.test(getall?.name)) {
        return getall;
      } else if (searchData.test(getall?.expId)) {
        return getall;
      } else if (searchData.test(getall?.restaurantName)) {
        return getall;
      } else {
        return false;
      }
    });
  }
  if (filtervalueModl) {
    filteredData = _data.filter((getall) => {
      if (filtervalueModl === true) {
        return getall.active === true;
      } else if (filtervalueModl === false) {
        return getall.active === false;
      } else {
        return getall;
      }
    });
  }
  if (userSort) {
    if (userSort === 1) {
      filteredData = _data.sort((a, b) => {
        let nameA = a && a.name.toLowerCase(); // ignore upper and lowercase
        let nameB = b && b.name.toLowerCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    } else if (userSort === 2) {
      filteredData = _data.sort((a, b) => {
        let nameA = a && a.name.toLowerCase(); // ignore upper and lowercase
        let nameB = b && b.name.toLowerCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return 1;
        }
        if (nameA > nameB) {
          return -1;
        }
        return 0;
      });
    }
  }
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Merchant Experience Management Dashboard
                </div>
                <div className="text-right">
                  <NavLink
                    to="#"
                    className="mr-4 px-5 py-2 btn addBtnRed f14-700"
                    style={{
                      color: '#f26856',
                      boxShadow: '0px 3px 6px #6E6E6E21',
                    }}
                  >
                    Add Experience
                  </NavLink>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-5 d-flex justify-content-start align-items-center"
                  style={{ marginBottom: '1%' }}
                >
                  <div
                    className={`newexpandablesearch mb-2 mr-2  ${
                      isActive ? 'active' : null
                    }`}
                  >
                    <div className="searchicon">
                      <i
                        onClick={() => {
                          setActive(!isActive);
                          setSearch('');
                        }}
                        className="fa fa-search"
                        aria-hidden="true"
                        style={{ fontSize: '20px' }}
                      ></i>
                    </div>
                    <div className="input">
                      <Form.Control
                        type="text"
                        placeholder="Experience Name/ID,Business Name"
                        className="newsearchinput"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                        style={{ borderRadius: '28px' }}
                      />
                      <i className="fa fa-timesw" aria-hidden="true"></i>
                    </div>
                  </div>
                  {/* <StatusFilter 
                        statusfilter={true}
                        values={(e) => {setFiltervaluefromModal(e)}}
                        /> */}
                  <div className="f10-400" align="center">
                    <div>
                      <div
                        className="f10-400"
                        align="center"
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                      >
                        <img
                          src={require('../../../../../assets/images/iconButton/sortbtn.svg')}
                          width="80px"
                        />
                      </div>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        {[
                          {
                            title: 'Sort by Experience Name',
                            value: 0,
                            disabled: true,
                          },
                          {
                            title: `A-Z`,
                            value: 1,
                            disabled: false,
                          },
                          {
                            title: 'Z-A',
                            value: 2,
                            disabled: false,
                          },
                        ].map((ele, index) => {
                          return (
                            <MenuItem
                              value={ele.value}
                              key={index}
                              onClick={() => setUserSort(ele.value)}
                              disabled={ele.disabled}
                              style={{ fontWeight: '700' }}
                            >
                              {ele.title}
                            </MenuItem>
                          );
                        })}
                      </Menu>
                    </div>
                  </div>
                  <div className="f10-400" align="center">
                    <img
                      src={require('../../../../../assets/images/iconButton/downloadbtn.svg')}
                      width="80px"
                      alt="icon"
                      title="Download"
                    />
                    <br />
                    {/* Download */}
                  </div>
                </div>
                <div
                  className="col-3 d-flex align-items-center"
                  style={{ paddingBottom: '15px' }}
                ></div>
                <div className="col-1 d-flex align-items-end"></div>
                <div className="col-3 d-flex align-items-center justify-content-end">
                  <div className="mr-3">
                    <SelectFilter onDateChange={() => {}} />
                  </div>
                </div>
              </div>
              <div className="Row">
                <div
                  onClick={(e) => setType(0)}
                  className={`mr-4 px-0 text-grayLink f12-700 btn btn-link ${
                    type === 0 && `active`
                  }`}
                >
                  Active Experiences
                </div>
                <div
                  onClick={(e) => setType(1)}
                  className={`mr-4 px-0 text-grayLink f12-700 btn btn-link   ${
                    type === 1 && `active`
                  }`}
                >
                  Archived Experiences
                </div>
              </div>
              <hr className="p-0 m-0" />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main mt-2">
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: '20%' }} className="f12-400">
                        Business Name/ID
                      </td>
                      <td style={{ width: '15%' }} className="f12-400">
                        My Experience/ <br />
                        Experience ID
                      </td>
                      <td style={{ width: '15%' }} className="f12-400">
                        Start Date
                        <br />
                        End Date
                      </td>
                      <td style={{ width: '10%' }} className="f12-400">
                        Pricing <br />
                        Adult & Kids
                      </td>
                      <td style={{ width: '10%' }} className="f12-400">
                        Category
                      </td>
                      <td style={{ width: '10%' }} className="f12-400">
                        Sub-Category
                      </td>
                      <td style={{ width: '8%' }} className="f12-400">
                        Status
                      </td>
                      {/* <td style={{ width: "8%" }} className="f12-400">
                        Primary
                      </td> */}
                      <td style={{ width: '14%' }} className="f12-400">
                        Actions
                      </td>
                    </tr>
                  </thead>
                  <tbody className="w-100 super-admin-all-vendor-main-table-body">
                    {filteredData?.length ? (
                      <React.Fragment>
                        {filteredData
                          ?.slice(pagination?.start, pagination?.end)
                          ?.map((data) => {
                            return (
                              <InnerComponent
                                data={data}
                                dispatch={dispatch}
                                removeExp={removeExp}
                                type={type}
                              />
                            );
                          })}
                        <BasicPagination
                          totalRecords={filteredData?.length || 0}
                          limit={10}
                          batch={pagination?.page}
                          onBatchChange={(e) => handleBatchChange(e)}
                        />
                      </React.Fragment>
                    ) : (
                      <NoContent />
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MerchantExperienceManagementDashboard;

const InnerComponent = ({ data, dispatch, removeExp, type }) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  const history = useHistory();
  return (
    <tr className="w-100 p-0">
      <td className="p-0 w-100">
        <table className="w-100">
          <tbody className="sd_body_css text-break">
            <tr onClick={showTr}>
              <td style={{ width: '20%' }}>
                <div>
                  <h5 className="font_16_b mt-3">
                    {data?.restaurantName || ''}
                  </h5>
                  <div className="f12-500">
                    {data?.restaurantId?.city || ''}
                  </div>
                  <div className="f12-400">{data?.restaurantId?._id || ''}</div>
                </div>
              </td>
              <td style={{ width: '15%' }}>
                <h3 className="font_20_m">{data?.name || ''}</h3>
                <div className="f12-400">{data?.expId || ''}</div>
              </td>
              <td style={{ width: '15%' }} onClick={(e) => e.stopPropagation()}>
                <h3 className="font_20_m">
                  {data?.startDate
                    ? moment(data?.startDate).format('Do MMM YYYY')
                    : ''}
                  <br />
                  {data?.endDate
                    ? moment(data?.endDate).format('Do MMM YYYY')
                    : ''}
                  <br />
                  <ViewExpSessions exp={data} />
                </h3>
              </td>
              <td style={{ width: '10%' }}>
                <h3 className="font_20_m">
                  {data?.adultPrice + '/-' || ''}
                  <br />
                  {data?.kidsPrice + '/-' || ''}
                </h3>
              </td>
              <td style={{ width: '10%' }}>
                <h3 className="font_20_m">{data?.category?.title || ''}</h3>
              </td>
              <td style={{ width: '10%' }}>
                <h3 className="font_20_m">{data?.subCategory?.title || ''}</h3>
              </td>
              <td style={{ width: '8%' }}>
                <Toggle
                  toggleFunction={() => {}}
                  checked={data?.active}
                  disabled={true}
                />
                <div style={{ fontSize: '8px' }} className="opacity5">
                  You cannot update the status
                </div>
              </td>
              {/* <td style={{ width: "8%" }}>
                <Toggle
                  toggleFunction={() => {}}
                  checked={data?.primary}
                  disabled={true}
                />
                <div style={{ fontSize: "8px" }}>
                  You cannot update the status
                </div>
              </td> */}
              <td
                style={{ width: '14%' }}
                onClick={(e) => {
                  if (!e) var e = window.event;
                  e.cancelBubble = true;
                  if (e.stopPropagation) e.stopPropagation();
                }}
              >
                <button
                  onClick={() =>
                    dispatch(
                      vendorDashboardfromAdmin(
                        data?.restaurantId?.vendor_id?._id,
                        () => {
                          history.push(
                            `/${
                              data?.expType === 'CURATED'
                                ? 'curatedDashboard'
                                : 'specialDashboard'
                            }/${data?._id}/${
                              moment().diff(moment(data?.endDate), 'days') > 0
                                ? 'history'
                                : 'booking'
                            }`
                          );
                        }
                      )
                    )
                  }
                  className="enViewDashboard btn btn-outline-danger d-flex align-items-center"
                >
                  <Image
                    src={require('../../../../../assets/images/ActionImages/image/onboarding.svg')}
                    alt="View"
                    title="View"
                    fluid
                    className="mr-2"
                    width="20px"
                  />
                  <div className="f9-500">View Dashboard</div>
                </button>
              </td>
            </tr>
            {TrDetail && (
              <>
                <tr className="sd_accordion_body p-1">
                  <td style={{ width: '11%' }}>
                    <div className="f12-400 text-red">More Actions</div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <ViewExpDetails id={data?._id} />
                      {type === 0 ? (
                        <SuperAdminDeleteExp
                          id={data?._id}
                          removeExp={removeExp}
                        />
                      ) : null}
                      <ShareLinkModal
                        userAppLink={data?.shareLink?.shortLink || ''}
                        webAppLink={`${webappUrl}/restaurant/${data?.restaurantId?._id}/experience/${data?._id}`}
                      />
                    </div>
                  </td>
                  <td style={{ width: '25%' }}>
                    <div className="f12-400">Venue</div>
                    <div className="f12-400">{data?.venueAddress}</div>
                  </td>

                  <td style={{ width: '10%' }}>
                    <div className="f12-400">Used Count</div>
                    <div className="f12-400">{data?.seatsBooked || 0}</div>
                  </td>
                  <td style={{ width: '10%' }}>
                    <div className="f12-400">Left</div>
                    <div className="f12-400">{data?.seatsLeft || 0}</div>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </td>
    </tr>
  );
};
